import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FiatPrecisionPipe } from "@modules/+new/shared/fiat-precision-pipe/fiat-precision.pipe";

@NgModule({
	declarations: [FiatPrecisionPipe],
	imports: [CommonModule],
	exports: [FiatPrecisionPipe],
	providers: [FiatPrecisionPipe]
})
export class FiatPrecisionPipeModule {}
